import axios from "@/axios";

export const namespaced = true


export const state = { }

export const getters = { }

export const mutations = { }

export const actions = {
    async deleteSignature({ commit }, obj) {
        try {
            return await axios.post('api/ordertransactions/signatures/delete', obj)
        }
        catch (error) {
            console.log("ERROR: ", error); //not handelleds
        }
    },
    clearData({ commit }) {
        commit("CLEAR_DATA");
    },
}
